const keys = {
    COACHES: '/coaches'
};

export default keys;

